define('headerUsersListView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'headerUsersListUserView',
  'template!headerUsersListView'
], function(
  App,
  module,
  Backbone,
  Marionette,
  _,
  Settings,
  UserView,
  Tpl
) {
  'use strict';

  module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    className: 'header-users-list-view',
    childView: UserView,
    childViewContainer: '.users-container',
    collection: new Backbone.Collection(),

    initialize: function () {
      this.collection = new Backbone.Collection();
      this.windowKeydownHandler = _.bind(this.onWindowKeydown, this);
      this.windowClickHandler = _.bind(this.onWindowClick, this);      
    },

    onShow: function () {
      $(document).on('keydown', this.windowKeydownHandler);
      $(document).on('click', this.windowClickHandler);
    },

    fetch: function () {     
      var defer = $.Deferred();
      var params = {
        lang: Settings.get('lang'),
        online: true 
      };     

      var url = Settings.url('compuzz2', 'v2/caccounts/usersActivity', params);

      if (this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: url,
        success: _.bind(function (users) {    
          this.collection.reset();

          var sortedUsers = [];
          sortedUsers = _.sortBy(users, function (user) {
            return user.firstName.toLowerCase() + ' ' + user.lastName.toLowerCase();
          });          

          _.each(sortedUsers, function (user) {
            var model = App.request('caccount-admins:get-model', user);
            if (user.secId !== Settings.get('currentUser').secId)
              this.collection.add(model);
          }, this);   
          
          defer.resolve(this.collection.models);
        }, this)
      });

      return defer.promise();
    },

    onDestroy: function() {    
      $(document).off('keydown', this.windowKeydownHandler);
      $(document).off('click', this.windowClickHandler);
    },

    open: function () {
      var defer = $.Deferred();

      if(!this.$el.is(':visible')) {
        this.fetch().done(_.bind(function () {
          if(this.collection.length > 0)
            this.$el.css('display', 'flex');
          defer.resolve();
        }, this));
      } else {
        defer.resolve();
      }

      return defer.promise();
    },

    close: function () {
      if(!this.$el.is(':visible'))
        return;
      
      this.$el.hide();
    },

    isVisible: function () {
      return this.$el.is(':visible');
    },

    onWindowKeydown: function(event) {
      if (event.key === 'Escape')
        this.close();   
    },

    onWindowClick: function(event) {           
      if (!event.target.closest('.header-users-list-view'))
        this.close(); 
    } 
  });
});
